import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { CenteredModalTemplate as template } from './centered-modal.template';
import { CenteredModalStyles as styles } from './centered-modal.styles';
import { Dialog } from '@microsoft/fast-foundation';

@customElement({
  name: 'centered-modal',
  template,
  styles,
})
export class CenteredModal extends FASTElement {
  @attr show: boolean = false;
  @attr allowOverlayClose: boolean = false;
  @attr header: string = '';
  @attr buttons: boolean = true;
  @observable public centeredDialog: Dialog;

  connectedCallback() {
    super.connectedCallback();
    if (this.allowOverlayClose) {
      this.centeredDialog.addEventListener('cancel', () => this.closeDialog());
    }
  }

  showChanged() {
    if (this.centeredDialog) {
      const _show: any = this.show;
      if (!this.show || _show === 'false') {
        this.centeredDialog.hide();
      } else {
        this.centeredDialog.show();
      }
    }
  }

  public closeDialog() {
    this.$emit('modalClosing', true);
    this.centeredDialog.hide();
  }

  public toggleDialog(isClosedModal) {
    if (isClosedModal) {
      this.$emit('modalClosing', true);
      this.centeredDialog.hide();
    }
  }
}
